import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { ICompany, ICompanyGroup } from 'bets.oddprovider.lib.common.ts/models'
import { IDefaultAction, IDefaultState } from 'fwork.react.apptemplate'
import { FilterQuery } from 'mongoose'
import axios from '../../apiClient/axios'
import { CompaniesApiClient } from '../../apiClient/companies'
import { CompaniesGroupsApiClient } from '../../apiClient/companiesGroups'
import { IApiClientResult } from 'fwork-jsts-common/src/apiClient'
import { ApiResponseGetListData } from 'fwork-jsts-common/src/api'

export interface ICompaniesGroupsAction extends IDefaultAction {
  payload?: ICompanyGroup[],
}

export interface ICompaniesGroupsState extends IDefaultState {
  payload?: ICompanyGroup[],
}

const initState: ICompaniesGroupsState = {}

export const companiesGroupsStateLoadFromApi = createAsyncThunk(
  'companiesGroupsStateLoadFromApi',
  async (arg: {
    where?: FilterQuery<ICompanyGroup>,
    onSuccess?: () => void,
    onError?: (msg?: string) => void,
    onFinally?: () => void
  }) => {
    const apiResult: IApiClientResult<ApiResponseGetListData<ICompanyGroup>> = await new CompaniesGroupsApiClient(axios).get({
      where: arg.where,
      sort: { name: 1 }
    })

    if (apiResult.success) {
      if (arg.onSuccess)
        arg.onSuccess()
    }
    else if (arg.onError)
      arg.onError(apiResult.msg)

    if (arg.onFinally)
      arg.onFinally()
    return apiResult
  }
)

export const companiesGroupsSlice = createSlice({
  name: 'companiesGroupsSlice',
  initialState: initState,
  reducers: {
    clear: (state) => {
      state.payload = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(companiesGroupsStateLoadFromApi.pending, (state) => {
      if (!state.options)
        state.options = {}
      state.options.loading = true
    })
    builder.addCase(companiesGroupsStateLoadFromApi.fulfilled, (state, response) => {
      if (state.options)
        state.options.loading = false
      state.payload = response.payload.data?.payload
    })
    builder.addCase(companiesGroupsStateLoadFromApi.rejected, (state) => {
      if (state.options)
        state.options.loading = false
    })
  }
})

export const { clear: clearCompaniesGroups } = companiesGroupsSlice.actions
export default companiesGroupsSlice.reducer